// Extracao de texto de PDF no navegador via pdf.js (client-side, gratuito,
// sem servico externo — coerente com o Firebase Spark sem Cloud Functions).
// O PDF precisa seguir o mesmo formato de tabela com cabecalho da colagem de
// texto (ver lib/importParser.ts): uma linha de cabecalho + uma linha por
// lead, delimitadas por tab/virgula/ponto-e-virgula. O texto extraido e
// entregue pronto para o parseTextoColado existente — nao duplica logica de
// parsing/validacao/dedup, so troca a origem do texto.
import * as pdfjsLib from "pdfjs-dist";
import pdfWorkerUrl from "pdfjs-dist/build/pdf.worker.min.mjs?url";

pdfjsLib.GlobalWorkerOptions.workerSrc = pdfWorkerUrl;

export async function extrairTextoDePdf(arquivo: File): Promise<string> {
  const buffer = await arquivo.arrayBuffer();
  const pdf = await pdfjsLib.getDocument({ data: buffer }).promise;

  const linhas: string[] = [];
  for (let numPagina = 1; numPagina <= pdf.numPages; numPagina++) {
    const pagina = await pdf.getPage(numPagina);
    const conteudo = await pagina.getTextContent();

    let linhaAtual = "";
    for (const item of conteudo.items) {
      if (!("str" in item)) continue; // TextMarkedContent — sem texto
      linhaAtual += item.str;
      if (item.hasEOL) {
        linhas.push(linhaAtual);
        linhaAtual = "";
      }
    }
    if (linhaAtual.trim() !== "") linhas.push(linhaAtual);
  }

  return recortarAPartirDoCabecalho(linhas).join("\n");
}

// PDFs costumam ter titulo/legenda antes da tabela em si — corta tudo antes
// da primeira linha que contem "empresa" (unica coluna obrigatoria do
// parser, ver lib/importParser.ts), pra nao virar cabecalho por engano.
function recortarAPartirDoCabecalho(linhas: string[]): string[] {
  const idx = linhas.findIndex((l) =>
    l
      .normalize("NFD")
      .replace(/[̀-ͯ]/g, "")
      .toLowerCase()
      .split(/[\t;,]/)
      .some((col) => col.trim() === "empresa"),
  );
  return idx === -1 ? linhas : linhas.slice(idx);
}
